<template>
  <section class="war-room-post-files-attached" @click="onFilesClick">
    <h3 class="war-room-post-files-attached__title">Files Attached</h3>
    <a
      v-for="(file, index) in files"
      :key="index"
      :title="file.name"
      data-test="file-link"
      class="war-room-post-files-attached__item"
      v-bind="getFileHrefAttrs(file)"
    >
      <div class="war-room-post-files-attached__info">
        <AttachmentIcon width="20" height="20" alt="Attached file icon" class="war-room-post-files-attached__icon" />
        {{ file.name }}
      </div>
      <NuxtImg
        v-if="isImage(file.url)"
        class="war-room-post-files-attached__image"
        :src="`${internalBaseUrl}${file.url}`"
        :alt="file.name"
      />
    </a>
  </section>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import AttachmentIcon from '@/assets/svg/attachment.vue.svg';
import type { IPostFile } from '@/types/community';
import warRoomSignUpMixin from '~/components/partials/war-room/WarRoomSignUp/warRoomSignUpMixin';

export default Vue.extend({
  name: 'WarRoomPostFilesAttached',
  components: {
    AttachmentIcon,
  },
  mixins: [warRoomSignUpMixin],
  props: {
    files: {
      type: Array,
      required: true,
    } as PropOptions<Array<IPostFile>>,
  },
  data() {
    return {
      internalBaseUrl: process.env.internalBaseUrl,
    };
  },
  methods: {
    onFilesClick() {
      // @ts-ignore, method is from mixin
      if (!this.$auth.loggedIn) this.openWarRoomSignUpModal();
    },
    getFileHrefAttrs(file: IPostFile) {
      return this.$auth.loggedIn ? { href: file.url, target: '_blank', rel: 'nofollow noopener noreferrer' } : {};
    },
    isImage(url: string) {
      return url.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/);
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-post-files-attached {
  padding: 16px 24px 24px;
  background: var(--theme-color-over-card);
  border-radius: 8px;

  &__title {
    @include body-semibold;

    color: var(--theme-color-text);
  }

  &__item {
    @include subhead;

    margin-top: 16px;
    color: var(--theme-color-sub-text);
    text-decoration: none;
    display: block;
  }

  &__info {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__image {
    max-width: 100%;
    max-height: 1500px;
    margin: 10px 0 0;
  }

  &__icon {
    margin-right: 8px;
  }
}
</style>
